import React, {ComponentProps} from 'react'
import FieldWithLabel, {FieldType} from './FieldWithLabel'

const MultipleLinesTextField = (props: Omit<ComponentProps<typeof FieldWithLabel>, 'type'>) => {
  return <FieldWithLabel {...props} type={FieldType.multipleLines}/>
}
MultipleLinesTextField.displayName = 'MultipleLinesTextField'
export default MultipleLinesTextField
